module.exports = __webpack_public_path__ + "media/images/mobile/mb-hamburger-a5f61f073235a605b6bf31171a237d8f.png";